<template>
    <div class="px-3">

            <v-tabs v-model="tab">
                <v-tab>Controle de pedidos</v-tab>
                <v-tab disabled>Dashboard Operações</v-tab>
                <v-tab>Gerenciador de templates</v-tab>
                <v-chip x-small class="mb-2 mt-2 px-1 ml-n3" color="info"
              ><span class="black---text">{{
                $t("sales.clientsList.underDev")
              }}</span></v-chip
            >
                
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <OpecOrders></OpecOrders>
                </v-tab-item>
                <v-tab-item>
                    
                </v-tab-item>
               <v-tab-item>
                    <TemplatesList></TemplatesList>
               </v-tab-item>
            </v-tabs-items>

    </div>
</template>
<script>
import OpecOrders from "./OpecOrders"
import TemplatesList from "./TemplatesList.vue";
export default {
    components: { OpecOrders, TemplatesList },
    data: () => ({
        tab: 0
    })
}
</script>